/* @flow */
import * as Immutable from 'immutable';
import { PasswordExpiryNotificationActions } from 'common/redux/actions/password';

const defaultState = Immutable.fromJS({});

export const passwordExpiry = (state = defaultState, action) => {
    switch (action.type) {
        case PasswordExpiryNotificationActions.DO_IT_LATER: {
            return state.setIn(['isNotificationVisible'], false);
        }
        case PasswordExpiryNotificationActions.SET_VISIBILITY: {
            const { payload } = action;
            return state.setIn(['isNotificationVisible'], payload.visible);
        }
        default:
            return state;
    }
};
